import { ca } from '@cian/analytics';
export function sendTeaserWebEvent(payload, action) {
  var banner = payload.banner,
    jsonQuery = payload.jsonQuery;
  ca('teaser', {
    sc: jsonQuery,
    product: {
      id: banner.id,
      name: "".concat(banner.name, "_").concat(action),
      position: banner.position,
      extra: {
        bannerPlace: banner.place,
        action: action,
        eventDate: Date.now()
      }
    }
  });
}